import { connect }            from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from '../../../actions/productDetails';
import { setUser } from '../../../actions/user'; 
import ProductDetails from './ProductDetails';

const mapStateToProps = (state) => {
  return {
    product: state.productDetails.get('product'),
    bidHistory: state.productDetails.get('bids'),
    createBidError: state.productDetails.getIn(['createBid', 'error']),
    currentUser: state.user.get('currentUser')
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    Object.assign(actions, { setUser }),
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);



// WEBPACK FOOTER //
// ./src/app/components/Views/ProductDetails/index.js